<script>
    // Aquí puedes agregar cualquier lógica adicional
import { panelController} from '../../../../stores/service'
import AdSlot from '../../../../components/ads/AdSlot.svelte'
$panelController.service = {
    ico: "components_dash/img-logo.png",
    nameRatting: "",
    nameService: "",
    name:'',
    date: "",
    key: 0,
    service:{
      mode:0,
      sub:false,
      super:false
    }
  };

  $panelController.viewMenu= {
    status: false,
    nav: false,
    menuService:false,
    mesa: 0,
    servicio:{
      time:{
        status:false,
        date:''
      },
      status:false
    },
    

  };
  $panelController.viewEvaluacion =  {
    status: false,
    nav: false,
    controllers: {
      btn: [
        {
          text: "Guardar",
          status: false,
          style: "btn-success",
          opc: 1,
        },
        {
          text: "Siguiente",
          status: false,
          style: "btn-primary",
          opc: 2,
        },
      ],
      inputs: [
        {
          active: true,
          index: 0,
          value: "",
          valid: true,
          styletxt: "",
        },
      ],
    },
    index: [false, false],
  };
  $panelController.viewLogin = {
    roluser: 4,
    url: { id: "", key: "", status: null },
    status: true,
    nav: false,
    controllers: {
      txt: {
        description: "",
        date: "",
        mess: "Por favor inicia sesión en tu cuenta para empezar a enviar ratinggs:",
      },
      btn: [
        {
          text: "Sign in with Google",
          status: false,
          style: "btn-lg px-auto btn-primary py-2 w-100",
          opc: 1,
        },
        {
          text: "Continuar",
          status: false,
          style: "btn-lg px-auto btn-primary py-2 w-100",
          opc: 3,
        },
        {
          text: "Crear cuenta",
          status: false,
          style: "btn-lg px-auto btn-primary py-2 w-100",
          opc: 1,
        },
      ],
    },
  };
  </script>
  
  <style>
    .thank-you-container {
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 100vh;
      background-color: #f8f9fa;
    }
  
    .thank-you-card {
      padding: 30px;
      border-radius: 10px;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
      background: white;
      max-width: 500px;
      text-align: center;
    }
  
    .thank-you-icon {
      font-size: 50px;
      color: #28a745;
    }
  </style>
  
  <div class="thank-you-container">
    <div class="thank-you-card">
      <div class="thank-you-icon mb-4">
        <i class="fas fa-check-circle"></i>
      </div>
      <h2 class="mb-3">¡Gracias por participar!</h2>
      <p class="mb-4">
        Tus respuestas son muy valiosas para nosotros, agradecemos tu tiempo.
      </p>

    </div>
  </div>

  <div class="text-center mt-3">
    <AdSlot />
  </div>
